import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useDecorativeIconMotion } from '../../primitives/useIconMotion.js';
import type { IconProps } from '../../primitives/types.js';

/** Map with location pin — pin drops in from above and bobs gently. */
export function IcnMap(props: IconProps): ReactNode {
  const animate = useDecorativeIconMotion();
  return (
    <Svg {...props} iconName="map">
      {/* Folded map — three panels with fold lines */}
      <path d="M2 4l4-2 4 2 4-2v10l-4 2-4-2-4 2z" />
      <line x1="6" y1="2" x2="6" y2="12" />
      <line x1="10" y1="4" x2="10" y2="14" />
      {/* Pin — bobs */}
      <g style={{ transformOrigin: '8px 9px' }}>
        {animate && (
          <animateTransform
            attributeName="transform"
            type="translate"
            values="0 0;0 -1;0 0;0 0"
            keyTimes="0;0.3;0.55;1"
            dur="2.4s"
            repeatCount="indefinite"
          />
        )}
        <path
          d="M8 6a1.8 1.8 0 0 1 1.8 1.8c0 1.4-1.8 2.7-1.8 2.7s-1.8-1.3-1.8-2.7A1.8 1.8 0 0 1 8 6z"
          fill="currentColor"
          stroke="none"
        />
      </g>
    </Svg>
  );
}
